module.exports = __webpack_public_path__ + "img/ic_timelapse.a77ec128.svg";